module.exports = [
	{
		"id": 45,
		"Jahr": 2014,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"VeranderungProzent": 3.8
	},
	{
		"id": 60,
		"Jahr": 2014,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"VeranderungProzent": -15.7
	},
	{
		"id": 75,
		"Jahr": 2014,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"VeranderungProzent": -1.7
	},
	{
		"id": 90,
		"Jahr": 2014,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"VeranderungProzent": -12.8
	},
	{
		"id": 120,
		"Jahr": 2014,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"VeranderungProzent": 2.9
	},
	{
		"id": 135,
		"Jahr": 2014,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"VeranderungProzent": 32.9
	},
	{
		"id": 150,
		"Jahr": 2014,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"VeranderungProzent": 15.1
	},
	{
		"id": 180,
		"Jahr": 2014,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"VeranderungProzent": 17.1
	},
	{
		"id": 195,
		"Jahr": 2014,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"VeranderungProzent": 10.3
	},
	{
		"id": 210,
		"Jahr": 2014,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"VeranderungProzent": 1.4
	},
	{
		"id": 240,
		"Jahr": 2014,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"VeranderungProzent": 17.3
	},
	{
		"id": 255,
		"Jahr": 2014,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"VeranderungProzent": 8.9
	},
	{
		"id": 270,
		"Jahr": 2014,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"VeranderungProzent": 0.1
	},
	{
		"id": 300,
		"Jahr": 2014,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"VeranderungProzent": -2.3
	},
	{
		"id": 315,
		"Jahr": 2014,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"VeranderungProzent": 202
	},
	{
		"id": 345,
		"Jahr": 2014,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"VeranderungProzent": 12.8
	},
	{
		"id": 360,
		"Jahr": 2014,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"VeranderungProzent": 9.4
	},
	{
		"id": 390,
		"Jahr": 2014,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"VeranderungProzent": 10.6
	},
	{
		"id": 405,
		"Jahr": 2014,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"VeranderungProzent": 9.5
	},
	{
		"id": 420,
		"Jahr": 2014,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"VeranderungProzent": 8.3
	},
	{
		"id": 435,
		"Jahr": 2014,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"VeranderungProzent": 11.8
	},
	{
		"id": 465,
		"Jahr": 2014,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"VeranderungProzent": 1.1
	},
	{
		"id": 480,
		"Jahr": 2014,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"VeranderungProzent": 10.7
	},
	{
		"id": 495,
		"Jahr": 2014,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"VeranderungProzent": 4.7
	},
	{
		"id": 525,
		"Jahr": 2014,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"VeranderungProzent": 28.8
	},
	{
		"id": 540,
		"Jahr": 2014,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"VeranderungProzent": 12.6
	},
	{
		"id": 570,
		"Jahr": 2014,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"VeranderungProzent": 14.7
	},
	{
		"id": 585,
		"Jahr": 2014,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"VeranderungProzent": 2.8
	},
	{
		"id": 615,
		"Jahr": 2014,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"VeranderungProzent": 41.7
	},
	{
		"id": 630,
		"Jahr": 2014,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"VeranderungProzent": 24
	},
	{
		"id": 645,
		"Jahr": 2014,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"VeranderungProzent": 41
	},
	{
		"id": 675,
		"Jahr": 2014,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"VeranderungProzent": 30.7
	},
	{
		"id": 690,
		"Jahr": 2014,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"VeranderungProzent": 5.7
	},
	{
		"id": 705,
		"Jahr": 2014,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"VeranderungProzent": 10.5
	}
];


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/components/svgQuarterMap/data/zhQuarterMapBevoelkerung.json
// module id = 161
// module chunks = 0